import { createContext, type ReactNode, useContext, useState } from "react";
import type { ChartSeries } from "./shared";

interface Highlight {
  /** The keys of the series to bring forward, or of what they add up. Null while nothing is. */
  keys: readonly string[] | null;
  set: (keys: readonly string[] | null) => void;
}

const HighlightContext = createContext<Highlight>({ keys: null, set: () => {} });

/** Lets a tag hovered or focused inside bring its series forward in the charts inside. */
export function HighlightScope({ children }: { children: ReactNode }) {
  const [keys, set] = useState<readonly string[] | null>(null);
  return <HighlightContext value={{ keys, set }}>{children}</HighlightContext>;
}

export const useHighlight = () => useContext(HighlightContext);

/** Whether `keys` name a series, by its own key or one of the keys it adds up. */
export const highlights = (keys: readonly string[], series: ChartSeries) =>
  keys.includes(series.key) || (series.members?.some(member => keys.includes(member)) ?? false);
